type SupportedMcapNormalizerMajor = 1 | 2;

function getSupportedMcapNormalizerMajor(
  normalizerVersion: string,
): SupportedMcapNormalizerMajor | null {
  const match = /^mcap-normalizer\/v(1|2)(?:\.\d+)*$/.exec(normalizerVersion);
  if (match?.[1] === '1') {
    return 1;
  }
  if (match?.[1] === '2') {
    return 2;
  }
  return null;
}

/** Whether a normalizer major produces the declared canonical MCAP layout. */
export function isSupportedMcapCanonicalPair(
  normalizerVersion: string,
  layoutProfile: string,
): boolean {
  const normalizerMajor = getSupportedMcapNormalizerMajor(normalizerVersion);
  return (
    (normalizerMajor === 1 && layoutProfile === 'time-clustered-v1') ||
    (normalizerMajor === 2 && layoutProfile === 'source-set-v2')
  );
}
